import images from '../../../static/images/RealtorLanding';

const CONSTANTS_COMMENTS = [
    {
        photo: images.photoUser1,
        flag: images.flagJapan,
        region: 'commentJapan'
    },
    {
        photo: images.photoUser,
        flag: images.flagAmerica,
        region: 'commentAmerica'
    },
    {
        photo: images.photoUser2,
        flag: images.flagGermany,
        region: 'commentGermany'
    }
];

export default CONSTANTS_COMMENTS;
